















































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class InputFormTel extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ required: true })
  tel1: string

  @Prop({ required: true })
  tel3: string

  @Prop({ required: true })
  tel2: string

  @Prop({ required: true })
  input: (value: string, field: string) => void
}
